var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"modalName":"attachmentsRegisterModal","title":"WYKAZ ZAŁĄCZNIKÓW","buttons":[],"register":_vm.register},on:{"opened":_vm.getAttachments}},[_c('AttachmentsTable')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-061aff80","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/viewer/registers/AttachmentsRegister.vue
// module id = 2091
// module chunks = 0